export default function ConvertStatusColor(row) {
  if (row.original.TurbineStatusStatus === 'Alarm') {
    return 'error-row';
  } else if (row.original.TurbineStatus === 'Wait') {
    return 'warning-row';
  } else {
    return '';
  }
}